<div class="btn-container container">
  <button color="primary" class="back" (click)="back()" mat-raised-button>
    <mat-icon matPrefix>chevron_left</mat-icon>
    <small>BACK</small>
  </button>
</div>
<!-- <div #layer class="iframe-layer"></div> -->

<app-preview-fundraiser />